// extracted by mini-css-extract-plugin
export default {"Cell":"styles_Cell__DfKQW"};